(function(app, dialog) {

    var _ourpaySelectServiceID = 'OURPAYSELECT';
    
    var giftWarning = ' - Gift recipient\'s address';

    var billingWatning = ' - Your billing address';

    var parceDeliveryOptions = function(deliveryOptions) {

        var result = [];
        if (deliveryOptions && deliveryOptions.length > 1) {
            _.each(deliveryOptions, function(option) {
                option.Name = $.f['_DeliveryOption_' + option.DeliveryOptions[0] + '_Title'] ||
                    option.DeliveryOptions[0];
                option.Description = $.f['_DeliveryOption_' + option.DeliveryOptions[0] + '_Description'] || '';
                result.push(option);
            });
            return result;
        }
        return null;
    };

    var parceCurrentAddress = function (data) {
        var mode = data.BasketMode || 0;
        if (mode !== 0) return {};

        var result = data.DeliveryAddress || {};
        result.PickupPointsEnabled = data.PickupPointsEnabled;
        result.DeliveryOptions = parceDeliveryOptions(data.DeliveryOptions);

        if (result.AdditionalData) {
            var additionalData = JSON.parse(result.AdditionalData);
            result.DeliveryOption = {
                PostServiceId: additionalData.PostServiceId,
                DeliveryOptions: additionalData.DeliveryOptions
            };
            !additionalData.ID && (result.AdditionalData = null);
        }

        return result;
    };

    var parceCurrentGiftAddress = function (data) {
        var mode = data.BasketMode;
        if (mode !== 1) return {};
        return data.DeliveryAddress || {};
    };

    var validate = function(value, validateType, minLinght, maxLength) {
        var isValid = true;
        var trimVal = (value || '').replace(/^\s*|\s*$/g, '');
        if (validateType == '*') {
            isValid = /.+/.test(trimVal);
        } else if (validateType == '@') {
            isValid =
                /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(trimVal);
        } else if (validateType == ' ' && trimVal == '') {
            return true;
        }
        if (isValid) {
            var length = trimVal.length;
            if (minLinght != null) {
                isValid = isValid && length >= minLinght;
            }
            if (maxLength != null) {
                isValid = isValid && length <= maxLength;
            }
        }
        return isValid;
    };

    var PickupPointField = Backbone.Model.extend({
        initialize: function() {
            _.bindAll(this, '_init', '_update');

            this.on('change:Selected', this.isValid);

            app.checkout.orderXhr.done(this._init);
            app.checkout.onUpdate(this._update);
        },

        _init: function(data) {
            var postcode = _.findWhere(data.DecorationInfoList, { Name: 'Postcode' });
            if (postcode) {
                this.postcodeOrigin = _.clone(postcode);
                this.postcodeOrigin.Name = 'PostcodePickup';
                this.postcodeOrigin.Label = GetPageTemplate('_PostcodePickupLabel');
                this.set('Postcode', new DecorationFieldModel(this.postcodeOrigin));
            }
        },

        _update: function(data) {
            this.set('IsEnabled', data.PickupPointsEnabled);
        },

        loadByPostcode: function (postCode) {
            var $def = new $.Deferred();
            this.trigger('loading', true);
            if (postCode) {
                app.checkout.getPickupPointsByPostcode({ postcode: postCode }, { hideErrors: true })
                    .then(function (data) {
                            var result = [];
                            if (data.Result && data.Value)
                                result = data.Value;
                            $def.resolve(result);
                        },
                        $def.resolve.bind($def, [])).always(_.bind(function () {
                            this.trigger('loading', false);
                        },
                        this));
            } else {
                $def.reject();
            }
            return $def.promise();
        },

        loadByCoordinates: function (postData) {
            postData.count = postData.count || null;
            var $def = new $.Deferred();
            this.trigger('loading', true);
            app.checkout.getPickupPointsByCoordinates(postData, { hideErrors: true })
                .then(function (data) {
                    var result = [];
                    if (data.Result && data.Value)
                        result = data.Value;
                    $def.resolve(result);
                }, $def.resolve.bind($def, [])).always(_.bind(function () {
                    this.trigger('loading', false);
                }, this));
            return $def.promise();
        },

        select: function (data) {
            this.set('Selected', data);
        },

        clear: function () {
            this.set('Selected', null, { silent: true });
            var postcode = this.get('Postcode');
            postcode && postcode.clear();
        },

        isValid: function () {
            var status = false;
            if (this.get('Selected')) {
                status = true;
            }
            this.trigger('validation', status);
            return status;
        },

        isEnabled: function () {
            return this.get('IsEnabled');
        }
    });

    var DecorationFieldModel = Backbone.Model.extend({
        idAttribute: 'Name',

        defaults: {
            isValid: null
        },

        pcaUpdateModel: function () {
            this.trigger('pcaUpdateModel');
        },

        setValue: function (value) {
            this.set('Value', value);
            var isValid = this.isValid();
            this._valueChanged(value, isValid, this.get('Name'));
            return this;
        },

        _valueChanged: function (value, isValid, name) {
            this.trigger('valueChanged', { value: value, isValid: isValid, name: name });
        },

        isValid: function (silent) {
            var isHidden = this.getHidden();
            var isValid = isHidden || this.checkValid();
            this.set('isValid', isValid, { silent: !!silent});
            return isValid;
        },

        checkValid: function () {
            var name = this.get('Name');
            var value = this.get('Value');
            var fieldValue = $('@newDelivery').find('#' + name).val();

            if (fieldValue != null && value != fieldValue) {
                this.set('Value', fieldValue, {silent: true});
            }

            return validate(this.get('Value'), this.get('Validate'), this.get('MinLength'), this.get('MaxLength'));
        },

        setChangedByUser: function () {
            this.set('changedByUser', true);
            return this;
        },

        clear: function () {
            this.set('changedByUser', false);
            this.set('Value', '', { silent: true });
            this.set('isValid', null, { silent: true });
            this.trigger('clear');
        },

        isChangedByUser: function () {
            return this.get('changedByUser');
        },

        setHidden: function(value) {
            var settings = CheckoutSettings.getBasketSettings();
            if (settings.PickupPointsWOBilling) {
                this.set('hidden', value);
            }
        },

        getHidden: function() {
            var settings = CheckoutSettings.getBasketSettings();
            if (settings.PickupPointsWOBilling) {
                return this.get('hidden');
            }
            return false;
        },
        getName: function() {
            return this.get('FieldName') || this.get('Name');
        }
    });

    var DecorationCollection = Backbone.Collection.extend({
        model: DecorationFieldModel,

        initialize: function () {
            _.bindAll(this, '_init', '_updateModels', '_fillPickupPointPostcode');
            this.PickupPointField = new PickupPointField();
            app.checkout.orderXhr.done(this._init);
        },

        _init: function (data) {
            this.origin = data.DecorationInfoList;
            this.update(data.DecorationInfoList);

            if (this.get('Postcode')) {
                this.listenTo(this.get('Postcode'), 'change:Value', this._fillPickupPointPostcode);
            }
        },

        // TBD: Use constants.
        setDeliveryType: function (opts) {
            if (opts.SATL) {
                this._deliveryType = 'SATL';
            } else if (opts.PPE) {
                this._deliveryType = 'PPE';
            } else {
                this._deliveryType = null;
            }
        },

        getDeliveryType: function () {
            return this._deliveryType;
        },

        save: function (callback, callbackErr) {

            if (this._savePendingFlag) {
                return false;
            } else {
                this._inProgressEvent(true);
            }

            var flagSetter = _.bind(function () {
                this._inProgressEvent(false);
            }, this);

            if (this.isValid()) {
                var address = {};
                this.each(function (m) { address[m.get('Name')] = m.getHidden() ? '' : m.get('Value'); });
                address.AuthComment = this._authComment;
                address.AuthToLeave = !!this._authComment;

                if (this.getDeliveryType() === 'PPE' && this.PickupPointField) {
                    var ppAddress = this.PickupPointField.get('Selected');
                    address.Postcode = ppAddress.Postcode;
                    address.AdditionalData = JSON.stringify(ppAddress);
                }

                var data = {};
                if (!IsAuthorized()) {
                    var details = app.getCustomerData();
                    if (!details.isValid) {
                        if (_.isFunction(callbackErr)) callbackErr();
                        flagSetter();
                        return;
                    }
                    data.email = details.email;
                    data.name = details.name;
                    data.parameters = details.parameters;
                }

                var xhr = IsAuthorized() ?
                    app.checkout.setUserDeliveryAddress(address) :
                    app.checkout.setPublicDeliveryAddress(address, data);

                xhr.then(this._updateModels)
                    .done(callback)
                    .fail(callbackErr)
                    .always(flagSetter);
            } else {
                //var errorDescription = this.map(function (m) { return { fieldName: m.get('Name'), isValid: m.get('isValid') } });
                if (_.isFunction(callbackErr)) callbackErr();
                flagSetter();
            }
            return true;
        },

        isValid: function () {
            // TBD: rewrite this strange overhead way to validate
            this.each(function (model) {
                model.isValid();
            });
            var isValid = Boolean(!this.where({ isValid: false }).length);
            var errorDescription = this.map(function (m) { return { fieldName: m.get('Name'), isValid: m.get('isValid') } });
            window.app && app.event && app.event.addressValidation(isValid, !isValid && JSON.stringify(errorDescription));

            if (this.getDeliveryType() === 'PPE' && this.PickupPointField) {
                isValid &= this.PickupPointField.isValid();
            }

            if (!isValid) {
                this._warningDialog && this._warningDialog.destroy();
                this._warningDialog = dialog({
                    title: GetPageTemplate('_fillFormProperly'),
                    message: GetPageTemplate('_FillAllFields')
                });
            }
            return isValid;
        },

        setActive: function (isActive) {
            this.isActive = isActive;
        },

        getAuthComment: function () {
            return this._authComment;
        },

        isAuthComment: function () {
            return this._authComment;
        },

        applySignature: function (val) {
            this._setAuthComment(val);
        },

        cancelSignature: function () {
            this.applySignature(null);
        },

        pcaUpdateModel: function () {
            this.each(function (model) {
                model.pcaUpdateModel();
            });
        },

        _setAuthComment: function (val) {
            this._authComment = val;
            this.trigger('change:AuthComment', this._authComment); //tbd: actually this is should be addition Decoration		    
        },

        _updateModels: function (data) {
            this.update(data.Value.DecorationInfoList);
            this.cancelSignature();
            this.PickupPointField && this.PickupPointField.clear();
            this.trigger('update');
            return data;
        },

        _fillPickupPointPostcode: function () {
            if (this.getDeliveryType() !== 'PPE' || !this.PickupPointField) {
                return;
            }

            var pickupPostCode = this.PickupPointField.get('Postcode');
            var postcode = this.get('Postcode');
            if (!pickupPostCode.isChangedByUser() && !this.PickupPointField.get('Selected')) {
                pickupPostCode.set('Value', postcode.get('Value'));
            }
        },

        _inProgressEvent: function(state) {
            this._savePendingFlag = state;
            this.trigger('inProgress', state);
        }
    });

    var GiftDecorationCollection = Backbone.Collection.extend({
        model: DecorationFieldModel,

        _prefix: 'gift_',

        initialize: function () {
            _.bindAll(this, '_init', '_updateModels', '_clear');
            this.PickupPointField = new PickupPointField();
            app.checkout.orderXhr.done(this._init);
        },

        _init: function (data) {
            this.origin = data.DecorationInfoList;
            this._updateModels();
        },

        save: function (callback, callbackErr) {

            if (this._savePendingFlag) {
                return false;
            } else {
                this._inProgressEvent(true);
            }

            var flagSetter = _.bind(function () {
                this._inProgressEvent(false);
            }, this);

            if (this.isValid()) {
                var address = this.getAddress();
                var data = this.getAuthData();

                var xhr = IsAuthorized() ?
                    app.checkout.setUserGiftAddress(address) :
                    app.checkout.setUserPublicGiftAddress(address, data);

                xhr.done(_.bind(function(data) {
                    this._clear();
                    if ($.isFunction(callback)) {
                        callback(data);
                    }
                }, this)).always(flagSetter);


            } else {
                kos.dialog.popup({
                    title: GetPageTemplate('_fillFormProperly'),
                    closeBtn: true,
                    message: 'Please enter</br>' + giftWarning
            });
                //var errorDescription = this.map(function (m) { return { fieldName: m.get('Name'), isValid: m.get('isValid') } });
                if (_.isFunction(callbackErr)) callbackErr();
                flagSetter();
            }
            return true;
        },

        getAddress: function() {
            var address = {};
            //var _additionalData = null;
            this.each(_.bind(function (m) {
                var name = m.get('Name').replace(this._prefix, '');
                address[name] = m.get('Value');
                //if (name === 'GiftMessage') {
                //    var message = m.get('Value') || '';
                //    _additionalData = _.extend({}, _additionalData || {}, { GiftMessage: message.replace(/^\s+|\s+$/g, '') });
                //} else {
                //    address[name] = m.get('Value');
                //}
            }, this));

            //if (_additionalData) {
            //    address.AdditionalData = JSON.stringify(_additionalData);
            //}

            return address;
        },

        getAuthData: function() {
            var data = {};
            if (!IsAuthorized()) {
                var details = app.getCustomerData();
                if (!details.isValid) {
                    return;
                }
                data.email = details.email;
                data.name = details.name;
                data.parameters = details.parameters;
            }
            return data;
        },

        isValid: function () {

            this.each(function (model) {
                model.isValid();
            });
            var isValid = Boolean(!this.where({ isValid: false }).length);

            /* USE GIFT EVENT */
            //var errorDescription = this.map(function (m) { return { fieldName: m.get('Name'), isValid: m.get('isValid') } });
            //window.app && app.event && app.event.addressValidation(isValid, !isValid && JSON.stringify(errorDescription));

            //if (!isValid) {
            //    this._warningDialog && this._warningDialog.destroy();
            //    this._warningDialog = dialog({
            //        title: GetPageTemplate('_fillFormProperly'),
            //        message: GetPageTemplate('_FillAllFields')
            //    });
            //}
            return isValid;
        },

        setActive: function (isActive) {
            this.isActive = isActive;
        },

        _updateModels: function () {
            var decoration = CheckoutSettings.getDecoration() || {};
            if (!decoration.Gift) return;

            var list = [];
            var prefix = this._prefix;
            $.each(decoration.Gift, function(i, field) {
                var name = field.Name;
                var fieldData = $.extend({}, field, { Name: prefix + name, FieldName: name });
                list.push(fieldData);
            });

            this.update(list);
            this.trigger('update');
        },

        _clear: function() {
            this.each(function(m) {
                m.set('Value', '');
            });
        },

        _inProgressEvent: function (state) {
            this._savePendingFlag = state;
            this.trigger('inProgress', state);
        }
    });

    var AddressModel = Backbone.Model.extend({
        idAttribute: 'ID',
        initialize: function (attrs) {
            _.bindAll(this);
            try {
                if (attrs.AdditionalData) {
                    this.set('LinkedAddress', JSON.parse(attrs.AdditionalData));
                } else {
                    this.set('LinkedAddress', null);
                }
            } catch (e) {
                noticeError(e);
            }
        },
        select: function () {
            app.checkout.applyDeliveryAddress(this);
            this.collection.trigger('Select', this.toJSON());
        }
    });

    var AddressListCollection = Backbone.Collection.extend({
        model: AddressModel,
        initialize: function () {
            _.bindAll(this, 'success');
        },
        fetch: function () {
            return app.checkout.getUserAddresses().then(this.success);
        },
        success: function (data) {
            var addresses = [];
            _.each(data.Value.AddressesList, function (address) {
                if (address.ID && address.ID !== '00000000-0000-0000-0000-000000000000') {

                    if (address.AdditionalData) {
                        var additionalData = JSON.parse(address.AdditionalData);
                        address.DeliveryOption = {
                            PostServiceId: additionalData.PostServiceId,
                            DeliveryOptions: additionalData.DeliveryOptions
                        };
                        !additionalData.ID && (address.AdditionalData = null);
                    }

                    addresses.push(address);
                }
            });
            this.update(addresses);
            return addresses;
        },
        setActive: function (isActive) {
            this.isActive = isActive;
        },
        isValid: function () {
            dialog({
                title: GetPageTemplate('bi_AddressIsNotValid'),
                message: GetPageTemplate('bi_PleaseChoseAnotherOrAddNewAddress')
            });
            return false;
        }
    });
    
    var BillingAddressModel = Backbone.Model.extend({
        idAttribute: 'ID',
        _updateEventName: '__update__',
        initialize: function () {
            _.bindAll(this, '_update');
            this.$ready = new $.Deferred();
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        getAuthComment: function () {
            return this.get('AuthComment');
        },
        clear: function () {
            if (this.update) {
                this.update(null);
            }
        },
        setActive: function (isActive) {
            this.isActive = isActive;
        },
        isValid: function () {
            return Boolean(this.get('ID'));
        },
        _update: function (data) {
            var address = data.BillingAddress;
            this.set(address);
            if (this.$ready.state() === 'pending') {
                this.$ready.resolve(address);
            } else {
                this.trigger(this._updateEventName, address);
            }
        },
        onUpdate: function (fn) {
            if ($.isFunction(fn)) {
                this.on(this._updateEventName, fn);
            }
        },
        ready: function () {
            return this.$ready.promise();
        }
    });

    var BillingDecorationCollection = Backbone.Collection.extend({
        model: DecorationFieldModel,

        _prefix: 'billing_',

        initialize: function () {
            _.bindAll(this, '_init', '_updateModels', '_setDecoration', '_clear');
            this.$ready = new $.Deferred();
            app.checkout.orderXhr.done(this._init);
        },

        _init: function (data) {
            this.origin = data.DecorationInfoList;
            var billingAddress = data.BillingAddress;
            if (!billingAddress && data.BasketMode === 0) {
                billingAddress = data.DeliveryAddress;
            }
            this._updateModels(billingAddress);
        },

        save: function (callback, callbackErr) {

            if (this._savePendingFlag) {
                return false;
            } else {
                this._inProgressEvent(true);
            }

            var flagSetter = _.bind(function () {
                this._inProgressEvent(false);
            }, this);

            if (this.isValid()) {
                var address = this.getAddress();
                var data = this.getAuthData();

                var xhr = IsAuthorized() ?
                    app.checkout.setUserBillingAddress(address) :
                    app.checkout.setUserPublicBillingAddress(address, data);

                xhr.done(_.bind(function (data) {
                    this._clear();
                    if ($.isFunction(callback)) {
                        callback(data);
                    }
                }, this)).always(flagSetter);


            } else {
                kos.dialog.popup({
                    title: GetPageTemplate('_fillFormProperly'),
                    closeBtn: true,
                    message: 'Please enter</br>' + billingWatning
                });
                if (_.isFunction(callbackErr)) callbackErr();
                flagSetter();
            }
            return true;
        },

        getAddress: function() {
            var address = {};

            this.each(_.bind(function (m) {
                var name = m.get('Name').replace(this._prefix, '');
                address[name] = m.get('Value');
            }, this));

            return address;
        },

        getAuthData: function () {
            var data = {};
            if (!IsAuthorized()) {
                var details = app.getCustomerData();
                if (!details.isValid) {
                    return;
                }
                data.email = details.email;
                data.name = details.name;
                data.parameters = details.parameters;
            }
            return data;
        },

        isValid: function (silent) {

            this.each(function (model) {
                model.isValid(silent);
            });
            var isValid = Boolean(!this.where({ isValid: false }).length);

            /* USE GIFT EVENT */
            //var errorDescription = this.map(function (m) { return { fieldName: m.get('Name'), isValid: m.get('isValid') } });
            //window.app && app.event && app.event.addressValidation(isValid, !isValid && JSON.stringify(errorDescription));

            return isValid;
        },

        setActive: function (isActive) {
            this.isActive = isActive;
        },

        _updateModels: function (billingAddress) {
            if (!billingAddress) {
                app.checkout.getUserAddresses()
                    .done(_.bind(function (data) {
                        var list = data && data.Value && data.Value.AddressesList || [];
                        var address = list[0] || null;
                        if (address && (!address.ID || address.ID === '00000000-0000-0000-0000-000000000000')) {
                            address = null;
                        }
                        this._setDecoration(address);
                    }, this));
            } else {
                this._setDecoration(billingAddress);
            }
        },

        _setDecoration: function (billingAddress) {
            var decoration = CheckoutSettings.getDecoration() || {};
            if (!decoration.Billing) return;
            var list = [];
            billingAddress = billingAddress || {};
            var prefix = this._prefix;

            $.each(decoration.Billing, function (i, field) {
                var name = field.Name;
                var value = billingAddress[name] || '';
                list.push($.extend({}, field, { Name: prefix + name, FieldName: name, Value: value || '' }));
            });

            this.update(list);
            this.$ready.resolve();
            this.trigger('update');
        },

        _clear: function () {
            this.each(function (m) {
                m.set('Value', '');
            });
        },

        _inProgressEvent: function (state) {
            this._savePendingFlag = state;
            this.trigger('inProgress', state);
        },

        ready: function(cb) {
            this.$ready.done(cb);
        }
    });

    var DeliveryAddressModel = Backbone.Model.extend({
        idAttribute: 'ID',
        initialize: function() {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        cancelSignature: function () {
            this.applySignature(null);
        },
        applySignature: function (text) {
            this.set({AuthToLeave: !!text, AuthComment: text});
            app.checkout.setAuthToLeave(this);
        },
        isAuthComment: function () {
            return this.getAuthComment();
        },
        getAuthComment: function () {
            return this.get('AuthComment');
        },
        clear: function () {
            if (this.update) {
                this.update(null);
            }
        },
        setActive: function (isActive) {
            this.isActive = isActive;
        },
        isValid: function () {
            return Boolean(this.get('ID'));
        },
        isPickupPoint: function () {
            var additionaData = this.get('AdditionalData') || {};
            return !!additionaData.ID;
        },
        _update: function (data) {
            this.set(parceCurrentAddress(data));
        }
    });

    var GiftDeliveryAddressModel = Backbone.Model.extend({
        idAttribute: 'ID',
        _updateEventName: '__update__',
        initialize: function() {
            _.bindAll(this, '_update');
            this.$ready = new $.Deferred();
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        getAuthComment: function () {
            return this.get('AuthComment');
        },
        clear: function () {
            if (this.update) {
                this.update(null);
            }
        },
        setActive: function (isActive) {
            this.isActive = isActive;
        },
        isValid: function () {
            return Boolean(this.get('ID'));
        },
        _update: function (data) {
            var address = parceCurrentGiftAddress(data);
            this.set(address);
            if (this.$ready.state() === 'pending') {
                this.$ready.resolve(address);
            } else {
                this.trigger(this._updateEventName, address);
            }
        },
        onUpdate: function(fn) {
            if ($.isFunction(fn)) {
                this.on(this._updateEventName, fn);
            }
        },
        ready: function() {
            return this.$ready.promise();
        }
    });

    var OurPaySelectPackage = Backbone.Model.extend({

        idAttribute: 'ID',

        defaults: {
            ID: '',
            Name: '',
            Amount: 0,
            Selected: false
        },

        initialize: function () {
            _.bindAll(this, 'select');
        },

        select: function() {
            this.set('Selected', true);
        }
    });

    var OurPaySelectPackages = Backbone.Collection.extend({
        model: OurPaySelectPackage,

        initialize: function () {
            _.bindAll(this, '_init', '_preUpdate', '_update', 'ready');
            this._xhr = app.checkout.getDeliveryServicePackageDetails()
                .done(this._init)
                .fail(_.bind(this._init, this));
        },

        _init: function (packages) {
            if (packages) {
                this.update(packages);
            }
            app.checkout.orderXhr.done(this._preUpdate);
            app.checkout.onUpdate(this._preUpdate);
        },

        _preUpdate: function (data) {

            if (this.length === 0) {
                this._xhr = app.checkout.getDeliveryServicePackageDetails()
                    .done(_.bind(function (packages) {
                        this.update(packages);
                        this._update(data);
                    }, this));
            } else {
                this._update(data);
            }
        },

        _update: function (data) {
            this.keepsilent = true;
            if (data.DeliveryServicePackageDetail) {
                var model = this.get(data.DeliveryServicePackageDetail.DeliveryServicePackageDetailID);
                model && model.select(true);
            } else {
                this.keepsilent = !app.models.delivery.options.isOurpaySelect();
                var first = this.first();
                first && first.select(true);
            }
            this.keepsilent = false;
        },

        ready: function (ex) {
            this._xhr.done(ex);
        }
    });

    var DeliveryOption = Backbone.Model.extend({
        idAttribute: 'PostServiceId',

        defaults: {
            Name: '',
            Title: '',
            Description: '',
            DeliveryOptions: [],
            Price: 0,
            Selected: false,

            Purchased: false,
            Packages: null,
            OurPaySelect: false,
            AgreedWithTerms: null,

            IsVisible: true,
            IsDeleted: false
        },

        initialize: function() {
            _.bindAll(this, 'select',  '_changePackage');
            this.set('OurPaySelect', this.id === _ourpaySelectServiceID);
            this._loadPackages();
        },

        _loadPackages: function() {
            if (this.id === _ourpaySelectServiceID && !this.get('Purchased')) {
                var packages = new OurPaySelectPackages();
                this.set('Packages', packages);
                this.listenTo(packages, 'change:Selected', this._changePackage);
            }
        },

        select: function() {
            this.set('Selected', true);
        },

        getData: function() {
            return _.omit(this.toJSON(), 'Packages', 'Purchased', 'IsDeleted');
        },

        getSelectedPackage: function () {
            var packages = this.get('Packages');
            return packages && packages.where({ Selected: true })[0] || null;
        },

        isOurpaySelect: function () {
            return this.id === _ourpaySelectServiceID;
        },

        _changePackage: function (model) {
            if (model.get('Selected')) {
                var packages = this.get('Packages');
                packages.each(function (m) {
                    m.set('Selected', m.id === model.id);
                });

                var data = {
                    deliveryAddressID: app.models.delivery.current.id || null,
                    type: 'OurPaySelect',
                    servicepackagedetailid: model.id,
                    deliveryoption: JSON.stringify(this.getData())
            };

                !packages.keepsilent && app.checkout.setDeliveryOption(data);
            }
        },

        update: function (optionData) {
            var agreedWithTermsState = this.get('AgreedWithTerms');

            if (optionData.PostServiceId === 'OURPAYSELECT' && optionData.IsAvailable === false) {
                optionData.Description = "The products in your basket do not qualify for 'SELECT' discount deliveries.";
            }

            this.set({
                Price: optionData.Price,
                Info: optionData.Info,
                Selected: optionData.Selected,
                Purchased: optionData.Purchased,
                Title: optionData.Title,
                Description: optionData.Description,
                IsAvailable: optionData.IsAvailable,
                AgreedWithTerms: agreedWithTermsState == null ? optionData.AgreedWithTerms : agreedWithTermsState
            });
        }
    });

    var DeliveryOptions = Backbone.Collection.extend({
        model: DeliveryOption,

        initialize: function () {
            _.bindAll(this, '_update', '_selected');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
            this.on('change:Selected', this._selected);
        },

        _update: function (data) {
            this.keepsilent = true;
            var options = this._parse(_.clone(data.DeliveryOptions), data.DeliveryServicePackageDetail);
            var allowOurpaySubscriptionForNewCustomer = false;
            
            /* Add/Update delivery options*/
            _.each(options, _.bind(function (option) {
                if (option.PostServiceId == _ourpaySelectServiceID && data.OurPaySelect) {
                    option.AgreedWithTerms = data.OurPaySelect.TermsAndConditions == 2;
                }

                var model = this.get(option.PostServiceId);
                model && model.update(option);
                !model && this.add(options);
            }, this));

            /* Remove absent options */
            this.each(_.bind(function(model) {
                var option = _.findWhere(options, { PostServiceId: model.id });
                model.set('IsDeleted', !option);
            }, this));

            /* Set visible options */
            this.each(_.bind(function(model) {
                var isVisible = true;
                if(model.id === _ourpaySelectServiceID && !data.DeliveryServicePackageDetail && !allowOurpaySubscriptionForNewCustomer){
                    isVisible = false;
                }
                model.set('IsVisible', isVisible);
            }, this));

            this.keepsilent = false;

            /* Select First option if current option isDeleted */
            var model = this.where({ Selected: true, IsDeleted: true })[0];
            model && this.first() && this.first().select();
        },

        _parse: function (options, packageDetail) {
            if (options && options.length > 1) {
                return _.map(options, function (option) {
                    option.PostServiceId = (option.PostServiceId || option.DeliveryOptions[0]).toUpperCase();
                    option.Name = $.f['_DeliveryOption_' + option.DeliveryOptions[0] + '_Title'] || option.DeliveryOptions[0];
                    option.Description = $.f['_DeliveryOption_' + option.DeliveryOptions[0] + '_Description'] || '';

                    if (option.PostServiceId === _ourpaySelectServiceID && packageDetail && packageDetail.Purchased) {
                        option.Description = GetPageTemplate('_Ops_description_remaining').replace(/\[\[Count\]\]/, packageDetail.CurrentCount);
                        option.Purchased = true;
                    }

                    return option;
                });
            }
            return [];
        },

        _selected: function (model) {
            if (model.get('Selected')) {
                this.each(function (m) {
                    m.set('Selected', m.id === model.id);
                });

                var selectedPackageID = null;

                if (app.models.packageDetails.get('Purchased')) {
                    selectedPackageID = app.models.packageDetails.get('DeliveryServicePackageDetailID');
                } else {
                    var selectedPackage = model.getSelectedPackage();
                    selectedPackageID = selectedPackage && selectedPackage.id || null;
                }

                var _deliveryAddressID = null;
                if (app.models.page.get('BasketMode') === 0) {
                    _deliveryAddressID = app.models.delivery.current.id || null
                } else {
                    _deliveryAddressID = app.models.delivery.giftCurrent.id || null
                }

                var data = {
                    deliveryAddressID: _deliveryAddressID, 
                    type: this.isOurpaySelect() && 'OurPaySelect' || '',
                    deliveryoption: JSON.stringify(model.getData()),
                    servicepackagedetailid: selectedPackageID
                };

                !this.keepsilent && app.checkout.setDeliveryOption(data);
            }
        },

        isOurpaySelect: function () {
            var model = this.where({ Selected: true })[0];
            return model && model.id === _ourpaySelectServiceID;
        },

        getOurpaySelectStatus: function() {
            var model = this.get(_ourpaySelectServiceID);
            return {
                available: model && model.get('IsAvailable'),
                selected: model && model.get('Selected')
            }
        },

        getOurpaySelectModel: function() {
            return this.get(_ourpaySelectServiceID);
        },

        getSelectedPackage: function () {
            var model = this.where({ Selected: true })[0];
            if (model && model.id === _ourpaySelectServiceID) {
                var packages = model.get('Packages');
                return packages && packages.where({ Selected: true })[0] || null;
            }
            return null;
        }
    });

    var options = new DeliveryOptions();

    var decoration = new DecorationCollection();

    var giftDecoration = new GiftDecorationCollection();

    var current = new DeliveryAddressModel();

    var giftCurrent = new GiftDeliveryAddressModel();

    //var billingAddress = new BillingAddressModel();
    var billingAddress = new BillingAddressModel();

    var billingDecoration = new BillingDecorationCollection();

    var addressesList = new AddressListCollection();

    app.models = _.extend({
        delivery: {
            options: options,
            current: current,
            giftCurrent: giftCurrent,
            billingAddress: billingAddress,
            billingDecoration: billingDecoration,
            addressesList: addressesList,
            decoration: decoration,
            giftDecoration: giftDecoration,
            isValid: function () {
                var mode = app.models.page.get('BasketMode');
                if (mode === 0) {
                    if (decoration.isActive) {
                        return decoration.isValid();
                    } else if (current.isActive) {
                        return current.isValid();
                    } else {
                        return addressesList.isValid();
                    }
                } else {
                    var isValid = false;
                    var warningText = [];

                    if (giftDecoration.isActive && billingDecoration.isActive) {
                        var gift = giftDecoration.isValid();
                        var billing = billingDecoration.isValid();

                        isValid = gift && billing;
                        !gift && warningText.push(giftWarning);
                        !billing && warningText.push(billingWatning);

                    } else if (giftDecoration.isActive) {
                        isValid = giftDecoration.isValid();
                        !isValid && warningText.push(giftWarning);
                    } else if (billingDecoration.isActive) {
                        isValid = billingDecoration.isValid();
                        !isValid && warningText.push(billingWatning);
                    } else {// if (giftCurrent.isActive) {
                        isValid = giftCurrent.isValid();
                        !isValid && warningText.push(giftWarning);
                    }

                    if (!isValid) {
                        kos.dialog.popup({
                            title: GetPageTemplate('_fillFormProperly'),
                            closeBtn: true,
                            message: 'Please enter</br>' + warningText.join('</br>')
                        });
                    }

                    return isValid;
                }
            }
        }
    }, app.models);

})(app, kos.dialog.popup);